// import React, { useState } from "react";
// import { Check, Palette, Save, RotateCcw } from "lucide-react";

// import { THEMES } from "../theme/themes";
// import { useTheme } from "../theme/ThemeProvider";

// import "./Appearance.css";

// const THEME_LIST = Object.entries(THEMES).map(
//   ([key, theme]) => ({
//     key,
//     ...theme,
//   })
// );

// function Appearance() {
//   const {
//     themeName,
//     changeTheme,
//     resetTheme,
//   } = useTheme();

//   const [selectedTheme, setSelectedTheme] =
//     useState(themeName);

//   const [saved, setSaved] = useState(false);

//   const handleThemeSelect = (themeKey) => {
//     setSelectedTheme(themeKey);

//     // LIVE PREVIEW
//     changeTheme(themeKey);

//     setSaved(false);
//   };

//   const handleSave = () => {
//     localStorage.setItem(
//       "dashboard_theme",
//       selectedTheme
//     );

//     setSaved(true);

//     setTimeout(() => {
//       setSaved(false);
//     }, 2500);
//   };

//   const handleReset = () => {
//     resetTheme();
//     setSelectedTheme("default");
//     setSaved(false);
//   };

//   return (
//     <div className="appearance-page">

//       {/* Header */}

//       <div className="appearance-header">
//         <div>
//           <h1>Customize Dashboard</h1>

//           <p>
//             Customize the appearance of your Snap4Me
//             workspace.
//           </p>
//         </div>

//         <div className="appearance-actions">

//           <button
//             type="button"
//             className="appearance-reset-btn"
//             onClick={handleReset}
//           >
//             <RotateCcw size={16} />
//             Reset
//           </button>

//           <button
//             type="button"
//             className="appearance-save-btn"
//             onClick={handleSave}
//           >
//             <Save size={16} />

//             {saved
//               ? "Saved"
//               : "Save Appearance"}
//           </button>

//         </div>
//       </div>

//       {/* Main */}

//       <main className="appearance-content">

//         {/* Theme section */}

//         <section className="appearance-card">

//           <div className="appearance-card-header">

//             <div className="appearance-card-icon">
//               <Palette size={20} />
//             </div>

//             <div>
//               <h2>Color Themes</h2>

//               <p>
//                 Pick a preset to change the look of
//                 your entire dashboard.
//               </p>
//             </div>

//           </div>

//           <div className="theme-grid">

//             {THEME_LIST.map((theme) => {

//               const isSelected =
//                 selectedTheme === theme.key;

//               return (
//                 <button
//                   key={theme.key}
//                   type="button"
//                   className={`theme-card ${
//                     isSelected
//                       ? "theme-card-selected"
//                       : ""
//                   }`}
//                   onClick={() =>
//                     handleThemeSelect(theme.key)
//                   }
//                 >

//                   {isSelected && (
//                     <span className="theme-check">
//                       <Check size={16} />
//                     </span>
//                   )}

//                   {/* Mini Preview */}

//                   <div
//                     className="theme-preview"
//                     style={{
//                       background:
//                         theme.bgPrimary,
//                       borderColor:
//                         theme.borderColor,
//                     }}
//                   >

//                     <div
//                       className="theme-preview-header"
//                       style={{
//                         background:
//                           theme.headerBg,
//                       }}
//                     />

//                     <div className="theme-preview-body">

//                       <div
//                         className="theme-preview-sidebar"
//                         style={{
//                           background:
//                             theme.sidebarBg,
//                         }}
//                       >
//                         <span
//                           style={{
//                             background:
//                               theme.sidebarActive,
//                           }}
//                         />
//                         <span />
//                         <span />
//                       </div>

//                       <div className="theme-preview-content">

//                         <div
//                           className="theme-preview-card"
//                           style={{
//                             background:
//                               theme.cardBg,
//                             borderColor:
//                               theme.borderColor,
//                           }}
//                         >
//                           <span
//                             style={{
//                               background:
//                                 theme.accentPrimary,
//                             }}
//                           />
//                           <span
//                             style={{
//                               background:
//                                 theme.bgSurfaceElevated,
//                             }}
//                           />
//                         </div>

//                         <div
//                           className="theme-preview-button"
//                           style={{
//                             background:
//                               theme.accentPrimary,
//                           }}
//                         />

//                       </div>

//                     </div>

//                   </div>

//                   <p className="theme-name">
//                     {theme.name}
//                   </p>

//                 </button>
//               );
//             })}

//           </div>

//         </section>

//         {/* Live Preview */}

//         <section className="appearance-card">

//           <div className="appearance-card-header">

//             <div className="appearance-card-icon">
//               <Palette size={20} />
//             </div>

//             <div>
//               <h2>Live Preview</h2>

//               <p>
//                 This is how your dashboard colors
//                 will appear.
//               </p>
//             </div>

//           </div>

//           <DashboardPreview />

//         </section>

//       </main>

//     </div>
//   );
// }


// /* =========================================================
//    DASHBOARD PREVIEW
//    ========================================================= */

// function DashboardPreview() {

//   const { theme } = useTheme();

//   return (
//     <div
//       className="dashboard-live-preview"
//       style={{
//         background: theme.bgPrimary,
//         color: theme.textMain,
//       }}
//     >

//       {/* Preview Sidebar */}

//       <div
//         className="preview-sidebar"
//         style={{
//           background: theme.sidebarBg,
//         }}
//       >

//         <div className="preview-logo">
//           Snap4Me
//         </div>

//         <div
//           className="preview-menu preview-menu-active"
//           style={{
//             background: theme.sidebarActive,
//           }}
//         >
//           Dashboard
//         </div>

//         <div className="preview-menu">
//           Brands
//         </div>

//         <div className="preview-menu">
//           Campaigns
//         </div>

//         <div className="preview-menu">
//           Jobs
//         </div>

//       </div>

//       {/* Preview Main */}

//       <div className="preview-main">

//         <div
//           className="preview-header"
//           style={{
//             background: theme.headerBg,
//             borderColor: theme.borderColor,
//           }}
//         >
//           Dashboard
//         </div>

//         <div className="preview-dashboard">

//           <h3
//             style={{
//               color: theme.textMain,
//             }}
//           >
//             Welcome back
//           </h3>

//           <div className="preview-kpis">

//             <div
//               className="preview-kpi"
//               style={{
//                 background: theme.cardBg,
//                 borderColor: theme.borderColor,
//               }}
//             >
//               <span
//                 style={{
//                   color: theme.textSub,
//                 }}
//               >
//                 Total Jobs
//               </span>

//               <strong
//                 style={{
//                   color: theme.accentPrimary,
//                 }}
//               >
//                 125
//               </strong>
//             </div>

//             <div
//               className="preview-kpi"
//               style={{
//                 background: theme.cardBg,
//                 borderColor: theme.borderColor,
//               }}
//             >
//               <span
//                 style={{
//                   color: theme.textSub,
//                 }}
//               >
//                 Campaigns
//               </span>

//               <strong
//                 style={{
//                   color: theme.accentPrimary,
//                 }}
//               >
//                 32
//               </strong>
//             </div>

//           </div>

//           <div
//             className="preview-large-card"
//             style={{
//               background: theme.cardBg,
//               borderColor: theme.borderColor,
//             }}
//           >

//             <div
//               className="preview-line"
//               style={{
//                 background:
//                   theme.bgSurfaceElevated,
//               }}
//             />

//             <div
//               className="preview-line short"
//               style={{
//                 background:
//                   theme.bgSurfaceElevated,
//               }}
//             />

//             <button
//               type="button"
//               style={{
//                 background:
//                   theme.accentPrimary,
//               }}
//             >
//               View Details
//             </button>

//           </div>

//         </div>

//       </div>

//     </div>
//   );
// }

// export default Appearance; 

import React, { useState } from "react";
import {
  Check,
  Palette,
  Save,
  RotateCcw,
} from "lucide-react";

import { THEMES } from "../theme/themes";
import { useTheme } from "../theme/ThemeProvider";

import {
  saveAppearance,
} from "../services/appearanceService";

import "./Appearance.css";

const THEME_LIST = Object.entries(THEMES).map(
  ([key, theme]) => ({
    key,
    ...theme,
  })
);

function Appearance() {
  const {
    themeName,
    changeTheme,
    resetTheme,
  } = useTheme();

  const [selectedTheme, setSelectedTheme] =
    useState(themeName);

  const [saved, setSaved] = useState(false);

  const handleThemeSelect = (themeKey) => {
    setSelectedTheme(themeKey);

    // LIVE PREVIEW
    changeTheme(themeKey);

    setSaved(false);
  };

  const handleSave = async () => {

    try {

      const response =
        await saveAppearance(
          selectedTheme
        );

      /*
       * Backend successfully saved the theme.
       */

      const savedTheme =
        response?.theme_key ||
        selectedTheme;

      localStorage.setItem(
        "dashboard_theme",
        savedTheme
      );

      setSaved(true);

      setTimeout(() => {
        setSaved(false);
      }, 2500);

    } catch (error) {

      console.error(
        "Failed to save appearance:",
        error
      );

      alert(
        error.message ||
        "Failed to save appearance."
      );
    }
  };

  const handleReset = async () => {

    try {

      const response =
        await saveAppearance(
          "default"
        );

      const savedTheme =
        response?.theme_key ||
        "default";

      resetTheme();

      setSelectedTheme(
        savedTheme
      );

      localStorage.setItem(
        "dashboard_theme",
        savedTheme
      );

      setSaved(true);

      setTimeout(() => {
        setSaved(false);
      }, 2500);

    } catch (error) {

      console.error(
        "Failed to reset appearance:",
        error
      );

      alert(
        error.message ||
        "Failed to reset appearance."
      );
    }
  };

  return (
    <div className="appearance-page">

      {/* Header */}

      <div className="appearance-header">
        <div>
          <h1>Customize Dashboard</h1>

          <p>
            Customize the appearance of your Snap4Me
            workspace.
          </p>
        </div>

        <div className="appearance-actions">

          <button
            type="button"
            className="appearance-reset-btn"
            onClick={handleReset}
          >
            <RotateCcw size={16} />
            Reset
          </button>

          <button
            type="button"
            className="appearance-save-btn"
            onClick={handleSave}
          >
            <Save size={16} />

            {saved
              ? "Saved"
              : "Save Appearance"}
          </button>

        </div>
      </div>

      {/* Main */}

      <main className="appearance-content">

        {/* Theme section */}

        <section className="appearance-card">

          <div className="appearance-card-header">

            <div className="appearance-card-icon">
              <Palette size={20} />
            </div>

            <div>
              <h2>Color Themes</h2>

              <p>
                Pick a preset to change the look of
                your entire dashboard.
              </p>
            </div>

          </div>

          <div className="theme-grid">

            {THEME_LIST.map((theme) => {

              const isSelected =
                selectedTheme === theme.key;

              return (
                <button
                  key={theme.key}
                  type="button"
                  className={`theme-card ${
                    isSelected
                      ? "theme-card-selected"
                      : ""
                  }`}
                  onClick={() =>
                    handleThemeSelect(theme.key)
                  }
                >

                  {isSelected && (
                    <span className="theme-check">
                      <Check size={16} />
                    </span>
                  )}

                  {/* Mini Preview */}

                  <div
                    className="theme-preview"
                    style={{
                      background:
                        theme.bgPrimary,
                      borderColor:
                        theme.borderColor,
                    }}
                  >

                    <div
                      className="theme-preview-header"
                      style={{
                        background:
                          theme.headerBg,
                      }}
                    />

                    <div className="theme-preview-body">

                      <div
                        className="theme-preview-sidebar"
                        style={{
                          background:
                            theme.sidebarBg,
                        }}
                      >
                        <span
                          style={{
                            background:
                              theme.sidebarActive,
                          }}
                        />
                        <span />
                        <span />
                      </div>

                      <div className="theme-preview-content">

                        <div
                          className="theme-preview-card"
                          style={{
                            background:
                              theme.cardBg,
                            borderColor:
                              theme.borderColor,
                          }}
                        >
                          <span
                            style={{
                              background:
                                theme.accentPrimary,
                            }}
                          />
                          <span
                            style={{
                              background:
                                theme.bgSurfaceElevated,
                            }}
                          />
                        </div>

                        <div
                          className="theme-preview-button"
                          style={{
                            background:
                              theme.accentPrimary,
                          }}
                        />

                      </div>

                    </div>

                  </div>

                  <p className="theme-name">
                    {theme.name}
                  </p>

                </button>
              );
            })}

          </div>

        </section>

        {/* Live Preview */}

        <section className="appearance-card">

          <div className="appearance-card-header">

            <div className="appearance-card-icon">
              <Palette size={20} />
            </div>

            <div>
              <h2>Live Preview</h2>

              <p>
                This is how your dashboard colors
                will appear.
              </p>
            </div>

          </div>

          <DashboardPreview />

        </section>

      </main>

    </div>
  );
}


/* =========================================================
   DASHBOARD PREVIEW
   ========================================================= */

function DashboardPreview() {

  const { theme } = useTheme();

  return (
    <div
      className="dashboard-live-preview"
      style={{
        background: theme.bgPrimary,
        color: theme.textMain,
      }}
    >

      {/* Preview Sidebar */}

      <div
        className="preview-sidebar"
        style={{
          background: theme.sidebarBg,
        }}
      >

        <div className="preview-logo">
          Snap4Me
        </div>

        <div
          className="preview-menu preview-menu-active"
          style={{
            background: theme.sidebarActive,
          }}
        >
          Dashboard
        </div>

        <div className="preview-menu">
          Brands
        </div>

        <div className="preview-menu">
          Campaigns
        </div>

        <div className="preview-menu">
          Jobs
        </div>

      </div>

      {/* Preview Main */}

      <div className="preview-main">

        <div
          className="preview-header"
          style={{
            background: theme.headerBg,
            borderColor: theme.borderColor,
          }}
        >
          Dashboard
        </div>

        <div className="preview-dashboard">

          <h3
            style={{
              color: theme.textMain,
            }}
          >
            Welcome back
          </h3>

          <div className="preview-kpis">

            <div
              className="preview-kpi"
              style={{
                background: theme.cardBg,
                borderColor: theme.borderColor,
              }}
            >
              <span
                style={{
                  color: theme.textSub,
                }}
              >
                Total Jobs
              </span>

              <strong
                style={{
                  color: theme.accentPrimary,
                }}
              >
                125
              </strong>
            </div>

            <div
              className="preview-kpi"
              style={{
                background: theme.cardBg,
                borderColor: theme.borderColor,
              }}
            >
              <span
                style={{
                  color: theme.textSub,
                }}
              >
                Campaigns
              </span>

              <strong
                style={{
                  color: theme.accentPrimary,
                }}
              >
                32
              </strong>
            </div>

          </div>

          <div
            className="preview-large-card"
            style={{
              background: theme.cardBg,
              borderColor: theme.borderColor,
            }}
          >

            <div
              className="preview-line"
              style={{
                background:
                  theme.bgSurfaceElevated,
              }}
            />

            <div
              className="preview-line short"
              style={{
                background:
                  theme.bgSurfaceElevated,
              }}
            />

            <button
              type="button"
              style={{
                background:
                  theme.accentPrimary,
              }}
            >
              View Details
            </button>

          </div>

        </div>

      </div>

    </div>
  );
}

export default Appearance;